export function generateErrorMessage(errorCode) {
  let errorMessage = "";
  console.log(errorCode);
  switch (errorCode) {
    case "auth/invalid-email":
      errorMessage = "auth:error.invalidEmailAddress";
      break;
    case "auth/user-disabled":
      errorMessage = "auth:error.userDisabled";
      break;
    case "auth/user-not-found":
      errorMessage = "auth:error.userNotFound";
      break;
    case "auth/email-not-found":
      errorMessage = "auth:error.emailNotFound";
      break;
    case "auth/popup-closed-by-user":
      errorMessage = "auth:error.popupClosedByUser";
      break;
    case "auth/wrong-password":
      errorMessage = "auth:error.wrongPassword";
      break;
    case "auth/email-already-in-use":
      errorMessage = "auth:error.emailAlreadyInUse";
      break;
    case "auth/weak-password":
      errorMessage = "auth:error.weakPassword";
      break;
    case "auth/invalid-credential":
      errorMessage = "auth:error.invalidCredentials";
      break;
    case "auth/operation-not-allowed":
      errorMessage = "auth:error.operationNotAllowed";
      break;
    case "auth/requires-recent-login":
      errorMessage = "auth:error.requiresRecentLogin";
      break;
    case "auth/too-many-requests":
      errorMessage = "auth:error.tooManyRequests";
      break;
    case "auth/user-token-expired":
      errorMessage = "auth:error.userTokenExpired";
      break;
    case "auth/invalid-user-token":
      errorMessage = "auth:error.userTokenInvalid";
      break;
    case "auth/network-request-failed":
      errorMessage = "auth:error.networkRequestFailed";
      break;
    case "auth/user-not-verified":
      errorMessage = "auth:error.userNotVerified";
      break;
    case "auth/username-exists":
      errorMessage = "auth:error.usernameAlreadyExists";
      break;
    case "Error: auth/username-exists":
      errorMessage = "auth:error.usernameAlreadyExists";
      break;
    case "auth/account-exists-with-different-credential":
      errorMessage = "auth:error.accountExistsWithDifferentCredential";
      break;
    case "":
      errorMessage = "";
      break;
    default:
      errorMessage = `Unknown error. ${errorCode}`;
  }
  return errorMessage;
}
